import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { OnyxOptional } from '@onyx/angular';
import { isNumber } from 'lodash';
import { Duration } from 'luxon';
import { DurationHelper } from '../helpers/duration.helper';
import type { DurationPipeOptions } from '../interfaces/common/duration-options';

@Pipe({
  name: 'duration',
})
export class DurationPipe implements PipeTransform {
  public transform(
    duration: OnyxOptional<Duration | number>,
    options?: DurationPipeOptions,
  ): string {
    if (duration == null) return '-';

    return DurationHelper.format(
      isNumber(duration)
        ? Duration.fromObject({ seconds: duration })
        : duration,
      options,
    );
  }
}
